import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// App theme options. "default" keeps the current app background image; "clean"
// swaps it for a flat, calm surface.
export type AppTheme = "default" | "clean";

const applyTheme = (theme: AppTheme) => {
  if (typeof document !== "undefined") {
    document.documentElement.dataset.theme = theme;
  }
};

type AppearanceState = {
  theme: AppTheme;
  setTheme: (theme: AppTheme) => void;
};

// Preference persisted in browser storage (localStorage) via zustand persist —
// the same standard used for the language preference.
export const useAppearanceStore = create<AppearanceState>()(
  persist(
    (set) => ({
      theme: "default",
      setTheme: (theme: AppTheme) => {
        applyTheme(theme);
        set({ theme });
      },
    }),
    {
      name: "appearance-storage",
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        applyTheme(state?.theme ?? "default");
      },
    },
  ),
);

// Apply the persisted (or default) theme as soon as the store is loaded.
applyTheme(useAppearanceStore.getState().theme);
